import React from 'react';
import ItemGalleryBlock from '../../../blocks/ItemGalleryBlock';
import WorkshopReplayBlock from '../../../blocks/ReplayBlock';
import Description from './Description';
import Details from './Details';
import IframeRegistration from './IframeRegistration';
import Speakers from './Speakers';

export const workshopModalblockComponents = {
  'details': Details,
  'description': Description,
  'speakers': Speakers,
  'gallery': ({ session, ...rest }) => <ItemGalleryBlock {...rest} item={session} />,
  // eslint-disable-next-line react/prop-types
  'replay': ({ session, ...rest }) => <WorkshopReplayBlock {...rest} item={session} />,
  'iframe-registration': IframeRegistration,
};
